import React, { useState, useEffect, useMemo, useContext } from 'react';
import { Card, Flex, Popover, Button, Result } from 'antd-mobile';
import _ from 'lodash';

import DateRangeButton from '../components/DateRangeButton';

import { UrlSearch } from "../../../utils/utils";
import BasicContext from '../BasicContext';
import { getPercentFormat, getSthousandsFormatNum, formatBillUnit, renderCountryCNameByBrevityCode, renderAccountCNameByOrgId } from "../utils/common";

import { CustomerSMSPurpose } from '../utils/const';
import { getDateRange } from '../utils/timeFormat';
import { getSmsType, setSmsType } from '../../localStorage';

import * as Api from "../../../api/usms";

import moment from 'moment';
import 'moment/locale/zh-cn';

import { Empty, Loading } from '../components';

import '../index.css';

const Item = Popover.Item;

export const NotUnknownDeduct = 2; // 发送状态未知是否计费-不计费
export const PostpaidType = 2;

const sendDateList = ["当日", "一周", "一月", "三月"];
const defaultRangeBtn = "当日"
const sendDefaultDateRange = getDateRange(defaultRangeBtn);

export default function SendStats(props) {
  moment.locale('zh-cn');
  const context = useContext(BasicContext);

  const countryList = context.countryList || [];
  const customerList = context.customers || [];
  const CompanyId = +UrlSearch("CompanyId");
  const Email = UrlSearch("Email");

  const smsType = getSmsType();

  const [sendDateRange, setSendDateRange] = useState(sendDefaultDateRange);
  const [selectProductVisible, setSelectProductVisible] = useState(false);

  // 统计
  const [totalData, setTotalData] = useState([]);
  const [loading, setLoading] = useState(false);

  const AccountList = useMemo(() => {
    const results = [];
    totalData.forEach(data => results.push(...(data.AccountAccumulateStatistics || [])));
    return results
  }, [totalData]);

  // 聚合Account统计信息
  const getAccountInfo = (list) => {
    return list.map((item) => {
      if (!item.AccountStatistics || !Array.isArray(item.AccountStatistics) || item.AccountStatistics.length === 0) {
        return item;
      }

      const AccountStatistics = _.cloneDeep(item.AccountStatistics);
      const results = AccountStatistics.reduce((accumulator, currentItem) => {
        const exists = accumulator.find(
          (item) =>
            item.AccountId === currentItem.AccountId &&
            item.BrevityCode === currentItem.BrevityCode &&
            item.Purpose === currentItem.Purpose
        );

        if (exists) {
          // 如果已存在，累加值
          exists.TotalCount += +currentItem.TotalCount;
          exists.AccountBillCount += +currentItem.AccountBillCount;
          exists.CompanyRevenue += +currentItem.CompanyRevenue;
          exists.ProductRevenue += +currentItem.ProductRevenue;
          exists.SuccessCount += +currentItem.SuccessCount;
          exists.Profits += +currentItem.Profits;
        } else {
          // 如果不存在，将当前item添加到累积器中
          accumulator.push(currentItem);
        }

        return accumulator;
      }, []);

      // 遍历计算成功率和利润率
      results.forEach((item) => {
        item.SuccessPercent = ((item.SuccessCount / item.TotalCount) * 100).toFixed(1);
        item.ProfitPercent = ((item.Profits / item.CompanyRevenue) * 100).toFixed(1);
      });

      item.AccountAccumulateStatistics = results;

      return item;
    });
  };

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    initData()
  }, [])

  const initData = () => {
    getList(sendDefaultDateRange);
  }

  const getList = (dates, params) => {
    const data = {
      StartTime: moment(dates[0]).startOf("day").unix(),
      EndTime: moment(dates[1]).endOf("day").unix(),
      CompanyId: [+CompanyId],
      GroupCondition: ["BrevityCode", "Purpose"],
      ...params
    }
    setLoading(true);
    setErrorMessage("");

    let Action = Api.GetCustomerStatistics

    Action(data).then(res => {
      if (res) {
        const list = res || [];
        setTotalData(getAccountInfo(list));
      }
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }

  const onDateChange = (dates) => {
    setSendDateRange(dates)
    getList(dates)
  }

  const getAlarmPercent = (record, percent = 80) => {
    let SuccessCount = record.SuccessCount; // + record.UnKnownCostCount;

    const render = getPercentFormat(SuccessCount, record.TotalCount);
    if ((record.SuccessCount / record.TotalCount * 100 < percent)) {
      return <span style={{ color: '#f44336' }}>{render}</span>
    }
    return <span style={{ color: '#4cd964' }}>{render}</span>
  }

  const renderList = () => {
    if (AccountList.length === 0) {
      return <Empty />
    }

    return AccountList.map((item, index) =>
      <Card full style={{ marginBottom: '8px' }}
        key={index}
      >
        <Card.Header title={`${index + 1}.AccountId: ${renderAccountCNameByOrgId(customerList, item.AccountId)}`} />
        <Card.Body>
          <div
            style={{ borderBottom: '1px solid #E9E9E9' }}
          >
            <Flex>
              <Flex.Item style={{ fontSize: '13px', padding: '1px' }}>
                <span>发送总数：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{getSthousandsFormatNum(item.TotalCount)}</span>
              </Flex.Item>
              <Flex.Item style={{ fontSize: '13px', padding: '1px' }}>
                <span>计费条数：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{getSthousandsFormatNum(item.AccountBillCount)}</span>
              </Flex.Item>
            </Flex>
            <Flex>
              <Flex.Item style={{ fontSize: '13px', padding: '1px' }}>
                <span>短信类型：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{CustomerSMSPurpose[item.Purpose]}</span>
              </Flex.Item>
              <Flex.Item style={{ fontSize: '13px', padding: '1px' }}>
                <span>成功率：</span>
                <span style={{ fontWeight: 'bold' }}>{getAlarmPercent(item)}</span>
              </Flex.Item>
            </Flex>
            <Flex>
              <Flex.Item style={{ fontSize: '13px', padding: '1px' }}>
                <span>国家：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{renderCountryCNameByBrevityCode(item.BrevityCode, countryList)}</span>
              </Flex.Item>
            </Flex>
            <Flex>
              <Flex.Item style={{ fontSize: '13px', padding: '1px' }}>
                <span>公司收入：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>${getSthousandsFormatNum(formatBillUnit(item.CompanyRevenue))}</span>
              </Flex.Item>
              <Flex.Item style={{ fontSize: '13px', padding: '1px' }}>
                <span>产品收入：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>${getSthousandsFormatNum(formatBillUnit(item.ProductRevenue))}</span>
              </Flex.Item>
            </Flex>
            <Flex>
              <Flex.Item style={{ fontSize: '13px', padding: '1px' }}>
                <span>利润：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>${getSthousandsFormatNum(formatBillUnit(item.Profits))}</span>
              </Flex.Item>
              <Flex.Item style={{ fontSize: '13px', padding: '1px' }}>
                <span>利润率(%)：</span>
                <span style={{ fontWeight: 'bold', color: '#3498DB' }}>{getPercentFormat(item.ProfitPercent, 100, 1)}</span>
              </Flex.Item>
            </Flex>
            {/* <Flex>
              <Flex.Item style={{ fontSize: '13px', padding: '1px' }}>
                <span>通道：</span>
                <span>{renderChannelCNameByChannelId(item.ChannelId, channelList)}</span>
              </Flex.Item>
            </Flex> */}
          </div>
        </Card.Body>
      </Card>
    )
  }

  const renderHeader = title => (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <h3>{title}</h3>
      <Popover mask
        overlayStyle={{ color: 'currentColor' }}
        visible={selectProductVisible}
        overlay={[
          (<Item key="Text" value="Text" disabled={smsType === 'Text'}>文本短信USMS</Item>),
          (<Item key="Video" value="Video" disabled={smsType === 'Video'} style={{ whiteSpace: 'nowrap' }}>视频短信ISMS</Item>),
        ]}
        align={{
          overflow: { adjustY: 0, adjustX: 0 },
          offset: [-10, 0],
        }}
        onVisibleChange={visible => setSelectProductVisible(visible)}
        onSelect={value => {
          setSmsType(value.key);
        }}
      >
        <Button type="primary" size='small' disabled style={{ fontSize: 12, width: 80, flexShrink: 0 }}>切换产品</Button>
      </Popover>
    </div>
  )

  return (
    <div className="container">
      {renderHeader(`${smsType === 'Text' ? 'USMS' : 'ISMS'} - ${Email}(${CompanyId})
        - 运营数据：`)}
      <DateRangeButton
        dateList={sendDateList}
        value={sendDateRange}
        style={{ margin: '10px 0' }}
        size="small"
        onChange={dates => onDateChange(dates)}
        defaultRangeBtn={defaultRangeBtn}
      />
      <Loading loading={loading} error={errorMessage}>

        {totalData.map((data, index) => (
          <Result
            key={index}
            style={{ marginBottom: '12px', padding: '8px 0 12px 0' }}
            // img={myImg('https://gw.alipayobjects.com/zos/rmsportal/pdFARIqkrKEGVVEwotFe.svg')}
            title="总计"
            message={<div>
              发送总数:
              <span style={{ margin: '0 12px 0 4px', fontWeight: 'bold', color: '#3498DB' }}>{getSthousandsFormatNum(data.TotalCount || 0)}</span>
              计费条数:
              <span style={{ margin: '0 12px 0 4px', fontWeight: 'bold', color: '#3498DB' }}>{getSthousandsFormatNum(data.BillCount || 0)}</span>
              成功率:
              <span style={{ margin: '0 12px 0 4px', fontWeight: 'bold' }}>{getAlarmPercent(data)}</span>
              公司收入:
              <span style={{ margin: '0 12px 0 4px', fontWeight: 'bold', color: '#3498DB' }}>${getSthousandsFormatNum(formatBillUnit(data.CompanyRevenue || 0))}</span>
              产品收入:
              <span style={{ margin: '0 12px 0 4px', fontWeight: 'bold', color: '#3498DB' }}>${getSthousandsFormatNum(formatBillUnit(data.ProductRevenue || 0))}</span>
              利润:
              <span style={{ margin: '0 12px 0 4px', fontWeight: 'bold', color: '#3498DB' }}>${getSthousandsFormatNum(formatBillUnit(data.Profits || 0))}</span>
              利润率(%):
              <span style={{ margin: '0 12px 0 4px', fontWeight: 'bold', color: '#3498DB' }}>{getPercentFormat(data.ProfitPercent || 0, 100, 1)}</span>
              销售人员:
              <span style={{ margin: '0 12px 0 4px', fontWeight: 'bold', color: '#3498DB' }}>{data.SalespersonName || '-'}</span>
            </div>}
          />
        ))}

        各个服务账号发送详情：
        {renderList()}
      </Loading>
    </div>
  )
}
